import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
import mapUtil from '@blade-sxp/map/components/index.vue';
import { TrackList, delTrackList, mapQuery, trackDevices, parentTrackDevices } from '@blade-sxp/search-center/api/index';
import DeviceListCard from '@blade-sxp/search-center/pages/components/result/components/deviced.vue';
import BackSite from '@blade-sxp/search-center/pages/components/result/components/backSite.vue';
import { searchCenterStore } from '@blade-sxp/search-center/store/searchCenter';
import MapLoading from '@blade/common/components/map-loading/index.vue';
import RouteLeft from '@blade-sxp/search-center/pages/components/result/components/route-left.vue';
import roiHoverTip from '@blade-sxp/search-center/pages/components/result/components/roiHoverTip.vue';
import { getAvgNum } from '@blade-sxp/screen/utils/index';
import markCard from '@blade-sxp/screen/components/mark/index.vue';
import MapLocationLabel from '@blade/common/components/map-doms/location-label.vue';
let AlarmCenter = class AlarmCenter extends Vue {
    routeDialogVisible;
    selectTrackId = 1;
    mainAngle = '';
    zoneId = '';
    selectZoneId = '';
    backZoneId = '';
    clickId = '';
    rootZoneId = '';
    oldZoneId = '';
    seletDeveceId = '';
    colors = colors;
    visibleConfirm = false;
    mapName = '';
    mapUrl = '';
    mapType = '';
    mapConfig = '';
    map;
    leftInfoList = [];
    lineList = [];
    lineId = '';
    mapPointArr = [];
    oldMapPointArr = [];
    num = 1;
    // 设备
    deviceListCard = [];
    deviceList = [];
    loading = false;
    progress = 0;
    roiList = [];
    zoneNameList = [];
    tips = [];
    leftChoseIndex = 0;
    cardList = [];
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    backImageCard = [];
    lineVertices = [];
    get toolTipsList() {
        return [...this.tips, ...this.deviceListCard, ...this.zoneNameList, ...this.cardList, ...this.backImageCard];
    }
    get clickZoneId() {
        return searchCenterStore.clickZoneId;
    }
    get isMap() {
        return searchCenterStore.isMap;
    }
    get choseIndex() {
        return searchCenterStore.choseIndex;
    }
    get animationDeviceId() {
        return searchCenterStore.animationDeviceId;
    }
    get isdevicedClick() {
        return searchCenterStore.isdevicedClick;
    }
    get selectNumber() {
        return searchCenterStore.selectNumber;
    }
    // // 获取地图
    getMapQuery(id) {
        searchCenterStore.updateChoseIndex(0);
        try {
            // this.mapUrl = '';
            this.lineId = 'line2d' + Math.random();
            this.lineList = [];
            this.deviceListCard = [];
            this.lineVertices = [];
            searchCenterStore.updateMapurl(this.mapUrl);
            if (id) {
                this.zoneId = id;
            }
            let zoneId = this.zoneId;
            zoneId &&
                zoneId !== '0' &&
                mapQuery(zoneId, this.$route.meta.code).then((res) => {
                    this.mapUrl = res?.mapImageUrl ?? '';
                    searchCenterStore.updateMapurl(this.mapUrl);
                    this.mapName = res.mapName;
                    this.mapType = res.mapType;
                    this.mapConfig = res.mapConfig;
                    this.setMainAngle(this.mapConfig);
                    this.getTrackDevices(zoneId);
                });
            searchCenterStore.updateZoneId('');
        }
        catch (error) {
            this.$message({
                message: error,
                type: 'warning',
            });
        }
    }
    // 回第一层级
    goFirst() {
        if (this.zoneId === this.rootZoneId)
            return;
        this.lineList = [];
        this.lineVertices = [];
        this.lineId = '';
        this.backImageCard = [];
        this.backZoneId = '';
        this.selectZoneId = '';
        this.zoneId = this.rootZoneId;
        searchCenterStore.updateClickZoneId('');
        this.getMapQuery();
    }
    mounted() { }
    onStart() {
        this.loading = true;
        this.progress = 0;
    }
    onProgress(progress) {
        this.progress = Number((parseInt(String((progress.loaded / progress.total) * 1000)) / 10).toFixed(2));
    }
    onEnd() {
        this.loading = false;
        this.getTrackDevices(this.zoneId);
    }
    onError(err) {
        this.loading = false;
        console.log(err);
    }
    // 回上一层
    goUp() {
        if (this.zoneId === this.rootZoneId)
            return;
        // 记录此时的zoneId
        this.backZoneId = this.zoneId;
        this.selectZoneId = '';
        searchCenterStore.updateChoseIndex(0);
        searchCenterStore.updateClickZoneId('');
        this.lineList = [];
        this.lineVertices = [];
        this.lineId = '';
        parentTrackDevices(this.zoneId)
            .then((res) => {
            if (res.parentId === '0')
                return;
            this.zoneId = res.parentId;
            this.getMapQuery();
        })
            .catch((e) => { });
    }
    zoomIn() {
        this.$refs.trackMap.zoomIn();
    }
    zoomOut() {
        this.$refs.trackMap.zoomOut();
    }
    // 还原地图
    handleResetMap() {
        this.$refs.trackMap.zoomReset();
    }
    getIndex(array) {
        // 确定下标展示
        array.forEach((element, index) => {
            element.showIndex = index + 1;
        });
        return array;
    }
    // 去除无坐标点设备
    delNoVertices(array) {
        array.forEach((item, itemIndex) => {
            if (!item.vertices) {
                array.splice(itemIndex, 1);
            }
        });
        return array;
    }
    getNoMap(item) {
        const ind = this.leftInfoList.findIndex((ele) => item.deviceId === ele.deviceId);
        return this.leftInfoList[ind].hasMap;
    }
    // 连线连续数字
    arrConcat(arr) {
        let newArr = arr.map((item) => {
            return Number(item);
        });
        let len = newArr.length;
        let output = [];
        let i;
        for (i = 0; i < len; i++) {
            let start = newArr[i];
            let j;
            for (j = i; j < len; j++) {
                if (newArr[j] + 1 !== newArr[j + 1]) {
                    break;
                }
            }
            i = j;
            if (start === newArr[j]) {
                output.push(start);
            }
            else {
                output.push(start + '-' + newArr[j]);
            }
        }
        return output;
    }
    // 设置主视角
    setMainAngle(angleData) {
        const mapConfig = JSON.parse(angleData);
        if (!mapConfig?.configJson)
            return;
        this.mainAngle = mapConfig?.configJson || null;
        // this.mainAngle = JSON.parse(mapConfig?.configJson);
    }
    // 获取热区提示框
    getRoiHover() {
        this.cardList = this.roiList.map((item, index) => {
            const vertices = this.mapType === '3D-Three.js' && item.relationType !== 'ROI_3D' ? item.position : getAvgNum(item.vertices)?.vertices;
            return {
                id: item.id,
                roiListId: this.mapType === '3D-Three.js' ? item.threeId : item.id,
                vertices,
                visible: false,
                isFront: true,
                vueConfig: {
                    instance: roiHoverTip,
                    data: {
                        showIndex: item.showIndex,
                        index: item.index,
                        mapPointArr: this.mapPointArr,
                        zoneId: item.zoneId,
                    },
                },
            };
        });
    }
    // 通过区域id同步卡片显示隐藏
    changeCardListVisibleById(id, status) {
        const cardList = this.cardList.find((item) => item.roiListId === id);
        cardList && (cardList.visible = status);
    }
    updateCardListVisibleById(id) {
        setTimeout(() => {
            const visible = !!(this.$refs.mapTools && this.$refs.mapTools.getToolsStatus('tooltips'));
            const cardList = this.cardList.find((item) => item.roiListId === id);
            cardList && (cardList.visible = visible);
        }, 2000);
    }
    // 获取地图设备坐标
    getTrackDevices(id) {
        this.lineList = [];
        this.roiList = [];
        this.zoneNameList = [];
        this.lineVertices = [];
        // searchCenterStore.updateChoseIndex(0);
        try {
            id &&
                id !== '0' &&
                trackDevices(id).then((res) => {
                    this.mapPointArr = res;
                    this.mapPointArr.forEach((item, index) => {
                        let showIndexArr = [];
                        this.leftInfoList.forEach((ele, eleIndx) => {
                            if ((item.deviceId === ele.deviceId && !ele.isHide) ||
                                (item.zoneId !== '0' && ele.treePath?.includes(item.zoneId) && !ele.isHide)) {
                                showIndexArr.push(ele.showIndex);
                            }
                        });
                        item.showIndex = showIndexArr.join();
                    });
                    this.mapPointArr = this.mapPointArr.filter((item) => item.showIndex);
                    this.mapPointArr.forEach((item) => {
                        item.showIndex = item.showIndex.split(',').join();
                    });
                    this.mapPointArr.sort((a, b) => {
                        return Number(a.showIndex.split(',')[0].split('-')[0]) - Number(b.showIndex.split(',')[0].split('-')[0]);
                    });
                    sessionStorage.setItem('mapPointArr', JSON.stringify(this.mapPointArr));
                    this.lineList = [
                        {
                            chooseIndex: this.choseIndex,
                        },
                    ];
                    if (this.mapType === '2D') {
                        this.roiList = this.mapPointArr
                            ?.filter((item, index) => item.zoneRoiVO?.relationDTO?.relationType === 'ROI_2D' || item.zoneRoiVO?.relationDTO?.relationType === 'ROI_3D')
                            ?.map((item) => {
                            return {
                                ...item.zoneRoiVO?.relationDTO,
                                id: item.zoneId,
                                zoneId: item.zoneId,
                                theme: 'roi',
                                vertices: item?.zoneRoiVO?.relationDTO?.vertices || null,
                                opacity: true,
                                showIndex: item.showIndex,
                                mapPointArr: this.mapPointArr,
                                // title: item.zoneRoiVO?.name,
                                onClick: () => {
                                    this.zoneId = item.zoneId;
                                    this.lineList = [];
                                    this.deviceListCard = [];
                                    this.zoneNameList = [];
                                    this.cardList = [];
                                    this.backImageCard = [];
                                    let chooseIndex = this.mapPointArr.findIndex((ele) => ele.showIndex === item.showIndex);
                                    // if (chooseIndex === 0 && item.zoneRoiVO) return this.getMapQuery();
                                    searchCenterStore.updateSelectNumber(Number(item.showIndex.split(',')[0]));
                                    if (this.mapPointArr?.length > 1 && chooseIndex !== this.choseIndex) {
                                        searchCenterStore.updateIsdevicedClick(false);
                                        searchCenterStore.updateChoseIndex(chooseIndex);
                                    }
                                    else {
                                        this.getMapQuery();
                                    }
                                },
                                onMouseEnter: () => {
                                    this.changeCardListVisibleById(item.zoneId, true);
                                },
                                onMouseLeave: () => {
                                    this.updateCardListVisibleById(item.zoneId);
                                },
                            };
                        });
                    }
                    else {
                        this.roiList = this.mapPointArr
                            ?.filter((item) => item.zoneRoiVO?.relationDTO?.relationType === 'MODEL_3D' ||
                            item.zoneRoiVO?.relationDTO?.relationType === 'ROI_3D' ||
                            item.zoneRoiVO?.relationDTO?.relationType === 'ROI_2D')
                            ?.map((item, index) => {
                            if (item.zoneRoiVO?.relationDTO?.relationType === 'ROI_3D' || item.zoneRoiVO?.relationDTO?.relationType === 'ROI_2D') {
                                return {
                                    ...item.zoneRoiVO?.relationDTO,
                                    threeId: item.zoneId,
                                    zoneId: item.zoneId,
                                    type: 'roi3d',
                                    vertices: item?.zoneRoiVO?.relationDTO?.vertices || null,
                                    opacity: true,
                                    showIndex: item.showIndex,
                                    mapPointArr: this.mapPointArr,
                                    onClick: () => {
                                        this.zoneId = item.zoneId;
                                        this.lineList = [];
                                        this.deviceListCard = [];
                                        this.zoneNameList = [];
                                        this.cardList = [];
                                        this.backImageCard = [];
                                        let chooseIndex = this.mapPointArr.findIndex((ele) => ele.showIndex === item.showIndex);
                                        searchCenterStore.updateSelectNumber(Number(item.showIndex.split(',')[0]));
                                        if (this.mapPointArr?.length > 1 && chooseIndex !== this.choseIndex) {
                                            searchCenterStore.updateIsdevicedClick(false);
                                            searchCenterStore.updateChoseIndex(chooseIndex);
                                        }
                                        else {
                                            this.getMapQuery();
                                        }
                                    },
                                    onMouseEnter: () => {
                                        this.changeCardListVisibleById(item.zoneId, true);
                                    },
                                    onMouseLeave: () => {
                                        this.updateCardListVisibleById(item.zoneId);
                                    },
                                };
                            }
                            else {
                                return {
                                    zoneId: item.zoneId,
                                    id: item.zoneRoiVO?.relationDTO?.name,
                                    opacity: true,
                                    showIndex: item.showIndex,
                                    mapPointArr: this.mapPointArr,
                                    title: item.zoneRoiVO.name,
                                    onClick: () => {
                                        this.zoneId = item.zoneId;
                                        this.lineList = [];
                                        this.deviceListCard = [];
                                        this.zoneNameList = [];
                                        this.cardList = [];
                                        this.backImageCard = [];
                                        let chooseIndex = this.mapPointArr.findIndex((ele) => ele.showIndex === item.showIndex);
                                        searchCenterStore.updateSelectNumber(Number(item.showIndex.split(',')[0]));
                                        if (this.mapPointArr?.length > 1 && chooseIndex !== this.choseIndex) {
                                            searchCenterStore.updateIsdevicedClick(false);
                                            searchCenterStore.updateChoseIndex(chooseIndex);
                                        }
                                        else {
                                            this.getMapQuery();
                                        }
                                    },
                                    onMouseEnter: () => {
                                        this.changeCardListVisibleById(item.zoneId, true);
                                    },
                                    onMouseLeave: () => {
                                        this.updateCardListVisibleById(item.zoneId);
                                    },
                                };
                            }
                        });
                        this.zoneNameList = res
                            ?.filter((item) => item.zoneRoiVO?.relationDTO?.relationType === 'ICON_3D')
                            ?.map((item, index) => {
                            return {
                                zoneId: item.zoneId,
                                vertices: item.zoneRoiVO?.relationDTO?.vertices[0],
                                visible: true,
                                mapPointArr: this.mapPointArr,
                                vueConfig: {
                                    instance: markCard,
                                    data: {
                                        zoneId: item.zoneid,
                                        name: item.zoneRoiVO?.name,
                                        url: item.zoneRoiVO?.relationDTO?.name,
                                        vertices: item.zoneRoiVO?.relationDTO?.vertices[0],
                                    },
                                },
                                emitMethods: {
                                    markClick: () => {
                                        this.zoneId = item.zoneId;
                                        let chooseIndex = this.mapPointArr.findIndex((ele) => ele.showIndex === item.showIndex);
                                        searchCenterStore.updateSelectNumber(Number(item.showIndex.split(',')[0]));
                                        if (this.mapPointArr?.length > 1 && chooseIndex !== this.choseIndex) {
                                            searchCenterStore.updateIsdevicedClick(false);
                                            searchCenterStore.updateChoseIndex(chooseIndex);
                                        }
                                        else {
                                            this.getMapQuery();
                                        }
                                    },
                                },
                            };
                        });
                    }
                    this.getRoiHover();
                    this.deviceList = this.mapPointArr;
                    this.deviceListCard = [];
                    this.mapPointArr.map((item) => {
                        if (item.zoneRoiVO?.relationDTO) {
                            if (this.mapType === '3D-Three.js' && item.zoneRoiVO?.relationDTO?.relationType !== 'ROI_3D') {
                                this.lineVertices.push(item.zoneRoiVO?.relationDTO.vertices[0]);
                            }
                            else {
                                this.lineVertices.push(getAvgNum(item.zoneRoiVO?.relationDTO.vertices).vertices);
                            }
                        }
                        else {
                            this.lineVertices.push(item.vertices);
                        }
                    });
                    let defaultIndex = this.mapPointArr.findIndex((item) => item.showIndex.split(',').includes(String(this.selectNumber)));
                    if (this.mapPointArr.length > 1) {
                        // 地图初始化无需动画
                        this.lineList.push({
                            id: this.mapType === '2D' ? this.lineId : '3dline' + this.lineId,
                            vertices: this.lineVertices,
                            lineColor: this.colors.createTaskFrameHover,
                            chooseIndex: defaultIndex,
                            devicePointChange: false,
                            onMouseEnter: () => {
                                searchCenterStore.updateIsLineHover(true);
                            },
                            onMouseLeave: () => {
                                searchCenterStore.updateIsLineHover(false);
                            },
                            onMoveCompleted: () => { },
                        });
                    }
                    else {
                        this.lineList = [];
                    }
                    this.deviceListCard =
                        this.mapPointArr?.map((item, index) => ({
                            id: index.toString() + Math.random(),
                            vertices: item.vertices,
                            vueConfig: {
                                instance: DeviceListCard,
                                data: { trackData: item, deviceId: item.deviceId, index: index, lineVertices: this.lineVertices },
                            },
                        })) ?? [];
                    this.tips =
                        this.mapPointArr?.map((item, index) => ({
                            ...item.zoneRoiVO?.relationDTO,
                            id: index.toString() + Math.random(),
                            vertices: getAvgNum(item?.zoneRoiVO?.relationDTO?.vertices)?.vertices || null,
                            vueConfig: {
                                instance: MapLocationLabel,
                                data: { title: item.zoneRoiVO?.name, icon: null },
                            },
                        })) ?? [];
                    this.backImageCard =
                        this.mapPointArr
                            ?.filter((item) => item.zoneId === this.backZoneId)
                            .map((item, index) => ({
                            id: index.toString() + Math.random(),
                            vertices: getAvgNum(item.zoneRoiVO.relationDTO.vertices)?.vertices,
                            vueConfig: {
                                instance: BackSite,
                                data: { trackData: item, deviceId: item.deviceId },
                            },
                        })) ?? [];
                });
        }
        catch (error) { }
    }
    // 获取列表
    getTrackList() {
        try {
            TrackList().then((res) => {
                if (res.length > 0) {
                    this.zoneId = res[0].rootZoneId;
                    this.rootZoneId = res[0].rootZoneId;
                    this.selectTrackId = 1;
                    this.leftInfoList = this.getIndex(res).map((item, index) => {
                        return {
                            id: item.id,
                            captureUrl: item.captureUrl,
                            deviceId: item.deviceId,
                            deviceName: item.deviceName,
                            zoneId: item.zoneId,
                            trackType: item.trackType,
                            chineseTrackType: item.chineseTrackType,
                            englishTrackType: item.englishTrackType,
                            trackTime: item.trackTime,
                            similarity: item.similarity,
                            hasMap: item.hasMap,
                            showIndex: item.showIndex,
                            treePath: item.treePath,
                            isHide: false,
                            trackTypeName: item.trackTypeName,
                            idempotentId: item.idempotentId,
                        };
                    });
                    const firstNoMapPonitIndex = this.leftInfoList.findIndex((item) => item.hasMap);
                    searchCenterStore.updateSelectNumber(firstNoMapPonitIndex);
                    this.getMapQuery();
                }
            });
        }
        catch (error) { }
    }
    handleClose() {
        this.$emit('update:routeDialogVisible', false);
        this.selectTrackId = 1;
        this.seletDeveceId = '';
        this.zoneId = '';
        this.num = 1;
        this.deviceListCard = [];
        this.lineList = [];
        this.loading = false;
        this.lineVertices = [];
        this.mapUrl = '';
        this.lineId = '';
        this.backZoneId = '';
        this.backImageCard = [];
        searchCenterStore.updateChoseIndex(0);
        searchCenterStore.updateClickZoneId('');
        searchCenterStore.updateSelectNumber(1);
    }
    changeRouteDialogVisible(bool) {
        this.num = 1;
        if (bool) {
            this.getTrackList();
        }
    }
    changeseletDeveceId(seletDeveceId) {
        searchCenterStore.updateSelectId(seletDeveceId);
    }
    changeIsMap(bool) {
        this.getMapQuery(this.clickZoneId);
    }
    changeClickZoneId(id) {
        this.selectZoneId = '';
        this.zoneId = id;
    }
    changeSelectNumber(selectNumber) {
        this.selectTrackId = selectNumber;
    }
    changeChoseIndex(index) {
        // 进行线动画对接 轨迹动画完成后 再进行下钻
        this.lineList = [
            {
                vertices: this.lineVertices,
                lineColor: this.colors.createTaskFrameHover,
                chooseIndex: index,
                id: this.mapType === '2D' ? this.lineId : '3dline' + this.lineId,
                onMouseEnter: () => {
                    searchCenterStore.updateIsLineHover(true);
                },
                onMouseLeave: () => {
                    searchCenterStore.updateIsLineHover(false);
                },
                onMoveCompleted: () => {
                    if (this.selectZoneId === this.zoneId)
                        return;
                    !this.isdevicedClick && this.getMapQuery();
                },
            },
        ];
    }
    // 隐藏
    hide(id, bool) {
        let ind = this.leftInfoList.findIndex((item) => item.id === id);
        this.$set(this.leftInfoList, ind, Object.assign(this.leftInfoList[ind], { isHide: bool }));
        this.getTrackDevices(this.zoneId);
    }
    // 删除
    del(id) {
        this.leftInfoList = [];
        this.mapPointArr = [];
        this.lineList = [];
        this.lineVertices = [];
        this.mapUrl = '';
        searchCenterStore.updateChoseIndex(0);
        searchCenterStore.updateSelectNumber(1);
        try {
            delTrackList(String(id.id)).then((res) => {
                this.$message({ type: 'success', message: `${this.$t('delSuccess')}`, customClass: 'zZindex' });
                this.visibleConfirm = false;
                this.selectTrackId = 0;
                this.getTrackList();
                this.$emit('track', id.idempotentId);
                // (this.$parent.$parent as any).getAllcount();
                if (res === 0) {
                    this.$emit('update:routeDialogVisible', false);
                    this.$parent.clearAllTrack();
                }
            });
        }
        catch (error) { }
    }
    // 选中
    selectTra(item, index) {
        if (item.isHide || !item.hasMap)
            return;
        searchCenterStore.updateClickZoneId('');
        if (this.selectTrackId === item.showIndex)
            return;
        searchCenterStore.updateIsdevicedClick(false);
        searchCenterStore.updateSelectNumber(item.showIndex);
        this.seletDeveceId = item.deviceId;
        this.selectZoneId = item.zoneId;
        let chooseIndex = this.mapPointArr.findIndex((item) => item.showIndex.split(',').includes(String(index + 1)));
        if (chooseIndex === 0 && this.zoneId !== item.zoneId)
            return this.getMapQuery(item.zoneId);
        if (chooseIndex === -1)
            return this.getMapQuery(item.zoneId);
        this.lineList = [
            {
                vertices: this.lineVertices,
                lineColor: this.colors.createTaskFrameHover,
                chooseIndex: chooseIndex,
                id: this.mapType === '2D' ? this.lineId : '3dline' + this.lineId,
                onMouseEnter: () => {
                    searchCenterStore.updateIsLineHover(true);
                },
                onMouseLeave: () => {
                    searchCenterStore.updateIsLineHover(false);
                },
                onMoveCompleted: () => {
                    // 在线动画完成后在进行地图下钻  需要轨迹动画完成后暴露出事件
                    if (this.selectZoneId === this.zoneId)
                        return;
                    !this.isdevicedClick && this.getMapQuery(this.selectZoneId);
                },
            },
        ];
    }
};
__decorate([
    Prop()
], AlarmCenter.prototype, "routeDialogVisible", void 0);
__decorate([
    Watch('routeDialogVisible')
], AlarmCenter.prototype, "changeRouteDialogVisible", null);
__decorate([
    Watch('seletDeveceId')
], AlarmCenter.prototype, "changeseletDeveceId", null);
__decorate([
    Watch('isMap')
], AlarmCenter.prototype, "changeIsMap", null);
__decorate([
    Watch('clickZoneId')
], AlarmCenter.prototype, "changeClickZoneId", null);
__decorate([
    Watch('selectNumber')
], AlarmCenter.prototype, "changeSelectNumber", null);
__decorate([
    Watch('choseIndex')
], AlarmCenter.prototype, "changeChoseIndex", null);
AlarmCenter = __decorate([
    Component({
        name: 'ResultPage',
        components: { mapUtil, RouteLeft, MapLoading },
        i18n: {
            messages: {
                'en-us': {
                    hide: 'Hide',
                    delete: 'Delete',
                    airport: 'Airport',
                    delSuccess: 'Deleted successfully',
                    noLocation: 'no location information',
                    deleteList: 'The popup will be closed after deleting the last list',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                    route: 'Route',
                },
                zh: {
                    hide: '隐藏',
                    delete: '删除',
                    airport: '航空站',
                    delSuccess: '删除成功',
                    noLocation: '无定位信息',
                    deleteList: '删除最后一个列表会关闭弹框，确认吗?',
                    cancel: '取消',
                    confirm: '确认',
                    route: '轨迹还原',
                },
            },
        },
    })
], AlarmCenter);
export default AlarmCenter;
